import 'babel-polyfill';
import svg4everybody from 'svg4everybody';
import $ from 'jquery';
import slick from 'slick-carousel/slick/slick.min.js';
//svg4everybody();
import select2 from 'select2';
//Hook up select2 to jQuery
select2($);

window.$ = $;
window.jQuery = $;

import 'ninelines-ua-parser';
import '@chenfengyuan/datepicker/dist/datepicker.js';
import tilt from 'tilt.js/src/tilt.jquery.js';
tilt($);

import 'magnific-popup'; 


